export default __webpack_public_path__ + "static/media/kahsh36Web.2338863b.png";